import useRelatedEntities from '~/services/loop54/hooks/useRelatedEntities';
import { reduceLoop54Product } from '~/services/loop54/utils';

export default function useRelatedResults(productId = '') {
    return useRelatedEntities(
        {
            entity: {
                id: productId,
                type: 'Product',
            },
            resultsOptions: {
                take: 10,
            },
        },
        (data) => ({
            ...data,
            results: reduceLoop54Product(data.results),
        }),
    );
}
